import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './Header.css';

const Header = () => {
  const { user, logout, isAuthenticated } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-logo">
          <img src="/logo.png" alt="Pop Map" className="header-logo-img" />
          <h1 className="header-logo-text">Pop <span>Map</span></h1>
        </div>

        <nav className="header-nav">
          {isAuthenticated ? (
            <div className="header-user-section">
              <span className="header-user-name">{user.name}</span>
              <button className="header-btn" onClick={handleLogout}>
                Log out
              </button>
            </div>
          ) : (
            <div className="header-auth-section">
              <span className="header-subtitle">Event Mapping Made Simple</span>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;